module.exports = __webpack_public_path__ + "static/media/line-size-4.16a2306e.svg";